// extracted by mini-css-extract-plugin
export var author = "author-preview-module--author--a2459";
export var category = "author-preview-module--category--7d24e";
export var headline = "author-preview-module--headline--d1293";
export var headlinePost = "author-preview-module--headline-post--c774d";
export var image = "author-preview-module--image--ae551";
export var info = "author-preview-module--info--eb5b6";
export var meta = "author-preview-module--meta--03914";
export var name = "author-preview-module--name--883b8";
export var paragraph = "author-preview-module--paragraph--67ba9";
export var position = "author-preview-module--position--a8b44";
export var preview = "author-preview-module--preview--eeecc";
export var seeAll = "author-preview-module--see-all--067f9";